import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireQuiz} from '../umpire-quiz';

export interface UmpireComponentQuiz
  extends UmpireComponent<UmpireComponentTypeEnum.QUIZ> {
  external_url: string;

  quiz: UmpireQuiz;
}
